import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 31 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.9574 25.908C14.2349 26.6304 13.0635 26.6304 12.3411 25.908L1.24107 14.8079C0.518601 14.0855 0.518601 12.9141 1.24107 12.1917L12.3411 1.09166C13.0635 0.369187 14.2349 0.369187 14.9574 1.09166C15.6798 1.81413 15.6798 2.98548 14.9574 3.70795L7.01552 11.6498H28.4492C29.4709 11.6498 30.2992 12.4781 30.2992 13.4998C30.2992 14.5215 29.4709 15.3498 28.4492 15.3498L7.01552 15.3498L14.9574 23.2917C15.6798 24.0141 15.6798 25.1855 14.9574 25.908Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }